import React, {PureComponent} from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import Navigation from './navigation'
import { BLUE } from '../colors';
import { getLink, PATH_HOME } from '../../routes';
import Favicon from '../ui/favicon'

const StyledTopbar = styled.div`
    background:${({color})=> color ? color : BLUE};
    display:flex;
    color:#fff;
    height:80px;
    flex-direction:row;
    align-items:center;
    position:fixed;
    top:0;
    left:0;
    right:0;
    z-index:99;
    .logo{
        text-decoration:none;
        display:inline-block;
        margin:0 20px;
        min-width:240px;
        img{
            height:40px;
            width:auto;
        }
    }
    @media (max-width: 1280px) {
        height:60px;
    }
`

const mapStateToProps = (state)=>{
    return {
        user: state.auth.user,
        workspace: state.auth.workspace
    }
}

class Topbar extends PureComponent{
    componentDidMount(){
        const {workspace} = this.props 
        document.title = `IPViewer | ${workspace.name}`
    }
    render(){
        const {workspace} = this.props
        const color = workspace && workspace.color
        return <StyledTopbar color={color}>
            {workspace && <Favicon url={workspace.faviconFile && workspace.faviconFile.key} />}
            <Link to={getLink(PATH_HOME)} className="logo">
                {workspace && <img src={workspace.logoFile && workspace.logoFile.key} />}
            </Link>
            <Navigation {...this.props} />
        </StyledTopbar>
    }

}

export default connect(mapStateToProps)(Topbar)


// WEBPACK FOOTER //
// ./src/components/app/topbar.js